import React from 'react'
import Footer from '../defaultComponents/Footer'

import styled from 'styled-components'
import Modal from '@mui/material/Modal';

import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import CheckIcon from '@mui/icons-material/Check';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import FilterListIcon from '@mui/icons-material/FilterList';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF6347',
    },
  },
});

const PageWrapper = styled.div`
  font-family: Inter;
`

const TitleBanner = styled.div`
  display: flex;
  justify-content: center;
`

const TitleBox = styled.div`
  font-size: 2rem;
  font-family: Montserrat;
  font-weight: bold;
  width: 90vw;
  padding-left: 2vw;
`

const AssetSearchBanner = styled.div`
  display: flex;
  justify-content: center;
`

const AssetSearchBox = styled.div`
  width: 90vw;
  padding: 2vh 2vw 0vh 2vw;

  display: flex;
  gap: 1vw;
  flex-direction: row;
  > * {
    flex: 1;
  }

  @media (max-width: 700px) {
    width: 80vw;
    flex-direction: column;
    display: none;
  }
`

const AssetClearBanner = styled.div`
  display: flex;
  justify-content: center;
`

const AssetClearSearchBox = styled.div`
  width: 90vw;
  padding: 2vh 2vw 0vh 2vw;

  @media (max-width: 700px) {
    width: 80vw;
  }
`

const AssetClearSearchButton = styled.button`
  width: 150px;
  border: 2px solid lightgrey;;
  border-radius: 3px;
  background: lightgrey;
  font-weight: bold;
  color: #333333;
  padding: 5px 0vw 5px 0vw;
  &:hover {
    background: #505050;
    border-color: #606060;
    color: #FFFFFF;
  }

  @media (max-width: 700px) {
    display: none;
  }
`

const AssetDashBanner = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`

const AssetBoxContainer = styled.div`
  min-height: 60vh;
  width: 90vw;
  gap: 1vw;
  padding: 2vw 2vw 2vw 2vw;

  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 700px) {
    grid-template-columns: repeat(1, 1fr);
    width: 80vw;

    height: 70vh;
    overflow: auto;

    margin-top: 20px;

    padding-bottom: 100px;
  }
`

const AssetBox = styled.div`
  border: 1px solid #E3E4E6;
  border-radius: 5px;
  background: white;

  display: flex;
  font-family: Inter;

  padding-top: 1vh;
  padding-bottom: 1vh;

  height: 250px;

  @media (min-width: 701px) {
    &:hover{
      transform: scale(1.05);
      border-color: black;
    }
  }

  @media (max-width: 700px) {

    height: 200px;
    padding-left: 10px;
  }
`

const AssetName = styled.div`
  font-size: 1.8rem;
  font-weight: bold;
  text-transform: uppercase;

  @media (max-width: 700px) {
    font-size: 1rem;
  }
`

const AssetDateInfo = styled.div`
  font-size: 1.3rem;
  font-weight: bold;

  @media (max-width: 700px) {
    font-size: 1rem;
  }
`

const AssetInfoBox = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  padding: 1vh 1vw 1vh 1vw;

  @media (max-width: 700px) {
    font-size: 1rem;
  }
`

const AssetUserInfo = styled.div`
  color: grey;
  font-weight: bold;
  font-size: 1rem;

  text-transform: uppercase;
  @media (max-width: 700px) {

    font-size: 1rem;
  }
`

const AssetHireID = styled.div`
  font-weight: bold;
  font-size: 1rem;
  color: tomato;

  display: flex;
  align-items: center;
  gap: 5px;

  &.RETURNING {
    color: #a252ad;
  }

  &.COMPLETE {
    color: #56a04c;
  }

  @media (max-width: 700px) {
    font-size: 1rem;
  }
`

const AssetReturnButton = styled.button`
  width: 100px;

  border: 2px solid #a252ad;
  border-radius: 3px;
  background: white;
  font-weight: bold;
  color: #a252ad;

  margin-top: 1vh;

  &:hover{
    background: #a252ad;
    color: white;
  }

  padding: 5px 0vw 5px 0vw;

  &.ModalButton {
    border: 2px solid tomato;

    &:hover{
      background: tomato;
      color: white;
    }

    color: tomato;
  }
`

const AssetReturnCancelButton = styled.button`
  width: 100px;

  border: 2px solid darkgrey;
  border-radius: 3px;
  background: white;
  font-weight: bold;
  color: darkgrey;

  margin-top: 1vh;

  &:hover{
    background: #F8F8F8;
  }

  margin-left: 5px;
  padding: 5px 0vw 5px 0vw;
`

const AssetReturnConfirmText = styled.div`
  color: #5dad52;
  font-weight: bold;
  margin-top: 10px;
`

const ReturnModalBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  background: white;
  border: 2px solid #000;
  border-radius: 15px;
  box-shadow: 24;
  padding: 1vw 2vw 1vw 2vw;

  @media (max-width: 700px) {
    width: 80vw;
    
    padding: 20px 20px 20px 20px;
  }
`

const ReturnModalTitle = styled.div`
  border-bottom: 1px solid black;
  font-size: 2rem;
  margin-bottom: 1vw;
`

const ReturnModalDetails = styled.div`
`

const ReturnModalAssetBoxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const ReturnModalAssetBox = styled.div`
  border: 1px solid lightgrey;
  border-radius: 15px;

  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 1vw;
  background: #F8F8F8;
  font-weight: bold;

  font-family: Montserrat;

  margin-top: 1vh;
  margin-bottom: 1vh;

  @media (max-width: 700px) {
    padding: 20px 20px 20px 20px;
  }
`

const MobileFilterModalBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border: 2px solid #000;
  border-radius: 15px;
  box-shadow: 24;
  padding: 1vw 2vw 1vw 2vw;

  @media (max-width: 700px) {
    width: 80vw;
    padding: 20px 20px 20px 20px;
  }

  display: flex;
  flex-direction: column;
  gap: 15px;
`

const MobileFilterButtonsContainer = styled.div`
  display: flex;
`

const MobileFilterOpenButton = styled.button`
  width: 150px;
  border: 2px solid lightgrey;;
  border-radius: 3px;
  background: lightgrey;
  font-weight: bold;
  color: #333333;
  padding: 5px 0vw 5px 0vw;
  &:hover {
    background: #505050;
    border-color: #606060;
    color: #FFFFFF;
  }

  display: flex;
  justify-content: center;
  align-items: center;

  gap: 5px;

  @media (min-width: 700px) {
    display: none;
  }
`

const MobileFilterClearButton = styled.button`
  width: 150px;
  border: 2px solid lightgrey;;
  border-radius: 3px;
  background: lightgrey;
  font-weight: bold;
  color: #333333;
  padding: 5px 0vw 5px 0vw;
  &:hover {
    background: #505050;
    border-color: #606060;
    color: #FFFFFF;
  }
`

export default function AssetReturnsInternal() {

  // Handling the hired data 
  const [hiredData, setHiredData] = React.useState([])
  const [displayData, setDisplayData] = React.useState([])
  const [confirmMessage, setConfirmMessage] = React.useState("")

  const getHiredData = async () => {
    try {
      const res = await fetch("https://ic360portalbackend.azurewebsites.net/api/InternalAssets/allAssets");

      const data = await res.json();

      // console.log(JSON.stringify(data));
      setHiredData(data)
      setDisplayData(data)
    } catch (error) {
      console.error("Error getting hired data")
    }
  }

  React.useEffect(() => {
    getHiredData()
  }, [])


  // -- Handling cleaning the data display data
  const formatDateString = (inputDate) => {
    const date = new Date(inputDate);

    // Get day, month, and year from the date
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0 indexed
    const year = date.getFullYear();

    // Convert the date to DD-MM-YYYY format
    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate
  }

  // -- RETURN MODAL
  const [open, setOpen] = React.useState(false);

  const [returnData, setReturnData] = React.useState({})
  const handleOpen = (entry) => {
    setOpen(true)
    setReturnData(entry)
  };
  const handleClose = () => {
    setOpen(false)
    setConfirmMessage("")
  };
  // -- Search Bar for employees

  const [filters, setFilters] = React.useState({
    employee: "",
    assetName: "",
    usageDate: "",
    usage_department: ""
  })

  const [searchEmployee, setSearchEmployee] = React.useState("")
  const [searchAsset, setSearchAsset] = React.useState("")
  const [searchDate, setSearchDate] = React.useState("")
  const [searchDepartment, setSearchDepartment] = React.useState("")
  const [searchStatus, setSearchStatus] = React.useState("")
  React.useEffect(() => {
    const applyFilters = () => {
      let filteredData = hiredData;

      if (filters.employee) {
        setSearchEmployee(filters.employee)
        filteredData = filteredData.filter(entry =>
          entry.usage_user_name.toLowerCase().startsWith(filters.employee.toLowerCase())
        );
      } else {
        setSearchEmployee("")
      }

      if (filters.assetName) {
        setSearchAsset(filters.assetName)
        filteredData = filteredData.filter(entry =>
          entry.asset_name.toLowerCase().startsWith(filters.assetName.toLowerCase())
        );
      } else {
        setSearchAsset("")
      }

      if (filters.department) {
        setSearchDepartment(filters.department)
        filteredData = filteredData.filter(entry =>
          entry.usage_department.toLowerCase().startsWith(filters.department.toLowerCase())
        );
      } else {
        setSearchDepartment("")
      }

      if (filters.date) {
        setSearchDate(filters.date)
        filteredData = filteredData.filter(entry =>
          entry.usage_date.toLowerCase().startsWith(filters.date.toLowerCase())
        );
      } else {
        setSearchDate("")
      }

      if (filters.status) {
        setSearchStatus(filters.status)
        filteredData = filteredData.filter(entry =>
          entry.usage_status.toLowerCase().startsWith(filters.status.toLowerCase())
        );
      } else {
        setSearchStatus("")
      }
      setDisplayData(filteredData);
    };

    applyFilters();
  }, [filters, hiredData]);

  const handleSearch = (value, field) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const handleClearFilters = () => {
    setFilters({
      employee: "",
      assetName: "",
      usageDate: "",
      status: ""
    })
  }

  // CONFIRMING RETURN
  
  const handleConfirmReturningAsset = async (targetUsage) => {
    const info = {
      targetAssetId: targetUsage,
      newStatus: "COMPLETE"
    }
    try {
      const response = await fetch('https://ic360portalbackend.azurewebsites.net/api/InternalAssets/UpdateAssetStatus', {
        method: 'POST',
        headers: {
          'Content-type': 'application/JSON',
        },
        body: JSON.stringify(info),
        credentials: "include"
      })
      setConfirmMessage("Successfully Confirmed")
      getHiredData();
    } catch(error) {
      console.error(error)
    }
  }

  // -- SEARCH MODAL FOR MOBILE
  const [mobileFilterOpen, setMobileFilterOpen] = React.useState(false);

  const handleMobileFilterOpen = () => {
    setMobileFilterOpen(true)
  };

  const handleMobileFilterClose = () => {
    setMobileFilterOpen(false)
  };

  // -- FETCHING DATA EVERY 30 SECONDS 
  React.useEffect(()=>{
    const intervalId = setInterval(getHiredData, 30000);
    return () => clearInterval(intervalId);
  },[])

  return (<>
    <Modal
      open={open}
      onClose={handleClose}
    >
      <ReturnModalBox>

        <ReturnModalDetails>
          <ReturnModalTitle>Confirming Details</ReturnModalTitle>
          <div>Asset being returned:</div>

          <ReturnModalAssetBoxContainer>
            <ReturnModalAssetBox>
              <div>{returnData.usage_quantity} x {returnData.asset_name} </div>
              <div>{formatDateString(returnData.usage_date)} {returnData.usage_time}</div>
              <div>{returnData.usage_user_name} - {returnData.usage_department} </div>
            </ReturnModalAssetBox>
          </ReturnModalAssetBoxContainer>
        </ReturnModalDetails>
        <AssetReturnButton onClick={()=>{handleConfirmReturningAsset(returnData.usage_id)}}>Confirm</AssetReturnButton>
        <AssetReturnCancelButton onClick={() => { handleClose() }}>Cancel</AssetReturnCancelButton>
        <AssetReturnConfirmText >{confirmMessage}</AssetReturnConfirmText>
      </ReturnModalBox>

    </Modal>
    <ThemeProvider theme={theme}> 
    <Modal
        open={mobileFilterOpen}
        onClose={handleMobileFilterClose}
      >
        <MobileFilterModalBox>
          <TextField
            variant="outlined"
            placeholder="Employee"
            onChange={(e) => { handleSearch(e.target.value, "employee") }}
            value={searchEmployee}
          />
          <TextField
            variant="outlined"
            placeholder="Asset Name"
            onChange={(e) => { handleSearch(e.target.value, "assetName") }}
            value={searchAsset}
          />

          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Department</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Department"
              onChange={(e) => { handleSearch(e.target.value, "department") }}
              value={searchDepartment}
            >
              <MenuItem value={""}>
                <em>None</em>
              </MenuItem>
              <MenuItem value={"Labour"}>Labour</MenuItem>
              <MenuItem value={"Engineering"}>Engineering</MenuItem>
              <MenuItem value={"Traffic"}>Traffic</MenuItem>
              <MenuItem value={"AllRoad"}>AllRoad</MenuItem>
            </Select>
          </FormControl>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              format="DD/MM/YYYY"
              onChange={(newValue) => {
                if (newValue !== null) {
                  const formattedDate = newValue.format('YYYY-MM-DD');
                  handleSearch(formattedDate, "date")
                } else {
                  handleSearch("", "date")
                }
              }}
              slotProps={{
                actionBar: {
                  actions: ["clear", 'cancel', "accept"]
                }
              }}
            />
          </LocalizationProvider>
          <MobileFilterButtonsContainer>
            <AssetReturnButton className="ModalButton" onClick={() => { handleMobileFilterClose() }}>Apply</AssetReturnButton>
            <AssetReturnCancelButton onClick={() => { handleMobileFilterClose() }}>Close</AssetReturnCancelButton>
          </MobileFilterButtonsContainer>
          <MobileFilterClearButton onClick={() => { handleClearFilters() }}>Clear Filters</MobileFilterClearButton>
        </MobileFilterModalBox>
      </Modal>
    </ThemeProvider>
    {/* <Navbar pageType="Dashboard" /> */}
    <ThemeProvider theme={theme}>
      <PageWrapper>
        <TitleBanner>
          <TitleBox>USAGE</TitleBox>
        </TitleBanner>
        <AssetSearchBanner>
          <AssetSearchBox>
          <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                onChange={(e) => { handleSearch(e.target.value, "status") }}
                value={searchStatus}
              >
                <MenuItem value={""}>
                  <em>None</em>
                </MenuItem>
                <MenuItem value={"Returning"}>Returning</MenuItem>
                <MenuItem value={"Live"}>Live</MenuItem>
                <MenuItem value={"Complete"}>Complete</MenuItem>
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              placeholder="Employee"
              onChange={(e) => { handleSearch(e.target.value, "employee") }}
              value={searchEmployee}
            />
            <TextField
              variant="outlined"
              placeholder="Asset Name"
              onChange={(e) => { handleSearch(e.target.value, "assetName") }}
              value={searchAsset}
            />

            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Department</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Department"
                onChange={(e) => { handleSearch(e.target.value, "department") }}
                value={searchDepartment}
              >
                <MenuItem value={""}>
                  <em>None</em>
                </MenuItem>
                <MenuItem value={"Labour"}>Labour</MenuItem>
                <MenuItem value={"Engineering"}>Engineering</MenuItem>
                <MenuItem value={"Traffic"}>Traffic</MenuItem>
                <MenuItem value={"AllRoad"}>AllRoad</MenuItem>
              </Select>
            </FormControl>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                format="DD/MM/YYYY"
                onChange={(newValue) => {
                  if (newValue !== null) {
                    const formattedDate = newValue.format('YYYY-MM-DD');
                    handleSearch(formattedDate, "date")
                  } else {
                    handleSearch("", "date")
                  }
                }}
                slotProps={{
                  actionBar: {
                    actions: ['clear']
                  }
                }}
              />
            </LocalizationProvider>
          </AssetSearchBox>
        </AssetSearchBanner>

        <AssetClearBanner>
          <AssetClearSearchBox>
            <AssetClearSearchButton onClick={() => { handleClearFilters() }}>Clear Filters</AssetClearSearchButton>
            <MobileFilterOpenButton onClick={handleMobileFilterOpen}><FilterListIcon />Filters</MobileFilterOpenButton>
          </AssetClearSearchBox>

        </AssetClearBanner>

        <AssetDashBanner>
          <AssetBoxContainer>
            {displayData.map((hireEntry) => (
              <AssetBox key={hireEntry.usage_id}>
                <AssetInfoBox>
                  <div>
                    <AssetName>{hireEntry.usage_quantity} <span style={{textTransform:"none"}}>x</span> {hireEntry.asset_name}</AssetName>
                    <AssetDateInfo>{formatDateString(hireEntry.usage_date)} {hireEntry.usage_time}</AssetDateInfo>
                    <AssetUserInfo>{hireEntry.usage_user_name} - {hireEntry.usage_department}</AssetUserInfo>
                  </div>
                  <div>
                    {/* <AssetHireID>HIRE ID: {hireEntry.usage_id}</AssetHireID> */}
                    {hireEntry.usage_status === "RETURNING" &&
                      <>
                        <AssetHireID className={hireEntry.usage_status}><PendingActionsIcon /> {hireEntry.usage_status}  </AssetHireID>
                        <AssetReturnButton onClick={() => handleOpen(hireEntry)}>CONFIRM</AssetReturnButton>
                      </>
                    }

                    {
                      hireEntry.usage_status === "COMPLETE" &&
                      <>
                        <AssetHireID className={hireEntry.usage_status}><CheckIcon /> {hireEntry.usage_status}  </AssetHireID>
                      </>
                    }
                    
                    {
                      hireEntry.usage_status === "LIVE" &&
                      <>
                        <AssetHireID className={hireEntry.usage_status}><ScheduleIcon /> {hireEntry.usage_status}  </AssetHireID>
                      </>
                    }
                  </div>
                </AssetInfoBox>
              </AssetBox>
            ))}
          </AssetBoxContainer>
        </AssetDashBanner>
        <Footer />
      </PageWrapper>
    </ThemeProvider>
  </>)
}
